
import { useEffect, useRef, useState } from "react";
import axios from "axios";
import "./ManagerCheckListReject.css";
import { useNavigate } from "react-router-dom";
import { format } from 'date-fns';
import { fetchSubmittedApplicationsRejected } from "../../../../services/complitedProfilesService";
import { capitalizeFirstLetter } from "../../../../utils/validations";

const ManagerCheckListReject = () => {
  const [managerChecklistReject, setSubmitted] = useState([]);
  const [selectedApp, setSelectedApp] = useState(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const storedUser = JSON.parse(localStorage.getItem("user"));
  const userId = storedUser?.userId;
  const effectRan = useRef(false);
  useEffect(() => {
    const fetchSubmitted = async () => {
      setLoading(true);
      try {
        const data = await fetchSubmittedApplicationsRejected();
        // ✅ Ensure it's an array
        const list = Array.isArray(data) ? data : [];

        // ✅ Sort by updatedDate (descending - latest first)
        const sorted = list.sort((a, b) => {
          const t1 = new Date(a.personalInformation?.updatedDate || 0);
          const t2 = new Date(b.personalInformation?.updatedDate || 0);
          return t2 - t1; // latest first
        });

        setSubmitted(sorted);
      } catch (err) {
        console.error("Failed to load managerChecklistReject applications", err);
        setSubmitted([]);
      } finally {
        setLoading(false);
      }
    };
    if (!effectRan.current) {
      fetchSubmitted();
    }
    return () => {
      effectRan.current = true;
    }


  }, []);



  const handleClick = (app) => {
    navigate("/checkList", { state: { application: app } });
  };

  return (
    <div>
      <h2>Manager Reject Checklist</h2>
      <div className="managerChecklistReject-table">
        {/* Always show header */}
        <div className="managerChecklistReject-header">
          {/* <div className="managerChecklistReject-col">Draft Id</div> */}
          <div className="managerChecklistReject-col">Full Name</div>
          <div className="managerChecklistReject-col">Job Position</div>
          <div className="managerChecklistReject-col">Submission Date and Time</div>
          <div className="managerChecklistReject-col">Remark</div>
          <div className="managerChecklistReject-col">Updated By</div>
          <div className="managerChecklistReject-col">Status</div>
          <div className="managerChecklistReject-col">Action </div>
        </div>

        {/* Conditional row rendering */}
        {managerChecklistReject.map((app) => {
          // Use the updatedDate that actually exists on the object
          const updatedDate = app.updatedDate || app.personalInformation?.updatedDate;

          const formattedDateTime = updatedDate
            ? format(new Date(updatedDate), "dd-MM-yyyy , hh:mm a")
            : "—";

          // Full name – fallback to direct fullName if givenName/surname not present
          const fullName = app.fullName ||
            `${app.personalInformation?.givenName || ""} ${app.personalInformation?.surname || ""}`.trim() ||
            "N/A";

          // You may also need to adjust other fields the same way
          return (
            <div key={app.employeeUniqueId} className="managerChecklistReject-row">

              {/* Full Name */}
              <div className="managerChecklistReject-col">{fullName}</div>

              {/* Job Position – adjust path if needed */}
              <div className="managerChecklistReject-col">
                {app.designnation ||"N/A"}
              </div>

              {/* Submission Date & Time */}
              <div className="managerChecklistReject-col">{formattedDateTime}</div>

              {/* Remark */}
              <div className="managerChecklistReject-col">{app.approvalComment || "-"}</div>

              {/* Updated By */}
              <div className="managerChecklistReject-col">
                {app.filledByName || "N/A"}
              </div>

              {/* Status */}
              <div className="managerChecklistReject-col">
                {capitalizeFirstLetter(app.status )}
              </div>

              {/* Action Button */}
              <div className="managerChecklistReject-col">
                <button
                  className="managerChecklistReject-view-button"
                  onClick={() => handleClick(app)}
                >
                  Verification
                </button>
              </div>
            </div>
          );
        })}

      </div>

    </div>
  );
};
export default ManagerCheckListReject